import { render } from "./Or_tableClaim.vue?vue&type=template&id=2b818d42&scoped=true&ts=true"
import script from "./Or_tableClaim.vue?vue&type=script&lang=ts"
export * from "./Or_tableClaim.vue?vue&type=script&lang=ts"

import "./Or_tableClaim.vue?vue&type=style&index=0&id=2b818d42&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b818d42"]])

export default __exports__